import { createApi } from '@reduxjs/toolkit/query/react';
import customFetchBase from '@/app/common/utils/customFetchBase';
import { getBaseApiPath } from '@/app/common/api/config';

const keywordTrackerApi = createApi({
  reducerPath: 'tracker',
  baseQuery: (...args: unknown[]) =>
    customFetchBase(getBaseApiPath(), ...args),
  tagTypes: [
    'keywordsNote',
    'keywordsPage',
    'keywordsForSelect',
    'KeywordsProgressChart',
    'tracker_info',
    'domains_for_updating',
    'KeywordsMap',
    'tags',
    'tagsForSelect',
    'landingUrlsForSelect',
    'landing_urls',
    'groups',
    'groupsForSelect',
    'competitors',
    'competitor_chart',
    'competitor_domain_metrics'
  ],
  endpoints: () => ({})
});

export default keywordTrackerApi;
